export const APP_COOKIE_PROJECT_ID = "don_project_id";
export const APP_COOKIE_APP_ORIGIN = "don_app_origin";
export const APP_COOKIE_REFERRER_USER_ID = "don_referrer_user_id";

export const APP_LOCAL_STORAGE_CLIENT_ID = "donistaClientId";
export const APP_LOCAL_STORAGE_CHOME_EXTENSION_NEVER_SHOW = "chrome-extension-never-show"
export const APP_LOCAL_STORAGE_EMAIL_FOR_SIGNIN = "emailForSignIn"
export const APP_LOCAL_STORAGE_RETURN_URL = "donistaReturnUrl"
export const APP_LOCAL_STORAGE_REOPEN_CODE_DIALOG = "donistaReopenCodeDialog"
export const APP_LOCAL_STORAGE_REOPEN_CODE_VALUE = "donistaReopenCodeValue"
export const APP_SESSION_STORAGE_ANON_REVEAL = "donistaAnonReveal"

export function isValidReturnUrl(url?: string | null): url is string {
    return !!url && url.startsWith('/') && !url.startsWith('//');
}

export const APP_SEARCH_PARAM_PROJECT_ID = "project_id";
export const APP_SEARCH_PARAM_APP_ORIGIN = "app_origin";
export const APP_SEARCH_PARAM_REFERRER_USER_ID = "referrer_user_id";

export const APP_CACHE_TAG_CATEGORIES = "categories"
export const APP_CACHE_TAG_PROJECTS = "projects"
export const APP_CACHE_TAG_USERS = "users"
export const APP_CACHE_TAG_FIELDS_OF_WORK = "fields-of-work"

/** Category ID for popular shops — also used as the default when no category is selected. */
export const POPULAR_SHOP_CATEGORY_ID = "7cf73328-5923-35c2-a121-fe82f0a09eac";

export { POPULAR_PROJECT_CATEGORY_ID, AMAZON_SHOP_ID } from "@donista/shared/constants/app-ids";

export const ALL_PROJECTS_CATEGORY_ID = "all";

export const SCROLL_TILE_WIDTH = "w-52";